var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('div',{staticClass:"status",style:({
		'background-color': _vm.bgColor,
		'color': 'white',
	})},[_vm._v(" "+_vm._s(_vm.status.replace(/_/g, ' '))+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }